import { Typography, Card, CardContent, Box } from "@mui/material";
import { useLocation, Navigate } from 'react-router-dom'
import { gameArray } from "../../utils/gameArrat";
import { LayoutContext } from '../../App';
import { useContext } from 'react';
import OrderBox from "./OrderBox";
import PriceBox from "./PriceBox";

const GamePage = () => {
    const location = useLocation()
    const pathArray = location.pathname.split('/')
    const gameId = pathArray[pathArray.length - 1]
    const { isMobile } = useContext(LayoutContext);
    const currentGame = gameArray.find(game => game.path === gameId)

    if (!currentGame) {
        return <Navigate to="/" replace />;
    }


    return (
        <Card>
            <CardContent>
                <Box
                    display="flex"
                    flexDirection={isMobile ? "row" : "column"}
                    alignItems="center"
                    justifyContent="center"
                    gap={2}
                >
                    <Box sx={{ borderRadius: '10px', width: isMobile ? 40 : 80, height: isMobile ? 40 : 80, backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img src={`/images/${currentGame.logo}`} alt={currentGame.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    </Box>
                    
                    <Typography variant="h5" >{currentGame.name}</Typography>
                    <Box maxWidth={isMobile ? '100%' : 700} textAlign="center">
                        <Typography variant="body1" color="textSecondary">{currentGame.about}</Typography>
                    </Box>
                </Box>

                <OrderBox game={currentGame} isMobile={isMobile} />

                <PriceBox game={currentGame} isMobile={isMobile} />

            </CardContent>
        </Card>
    );
};

export default GamePage;